import { getFirstName, getInitials } from "@vincer/utils";
import { LogOut } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { supabase } from "@/lib/supabase";
import { useUser } from "@/hooks/useUser";

import { Avatar, AvatarFallback } from "../ui/avatar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";

export function Header() {
  const navigate = useNavigate();
  const { data: user } = useUser();
  const welcomeMessage = user
    ? `Welcome back, ${getFirstName(user?.name)}`
    : `Welcome to Your Mentorship Journey!`;

  const handleSignOut = async () => {
    await supabase.auth.signOut();

    navigate("/auth/login");
  };

  return (
    <header className="fixed inset-x-0 top-0 z-50 w-full border-b bg-primary px-8 py-1">
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <img
            src="/logo-vincer.png"
            alt="Logo"
            className="h-[40px] w-[120px]"
          />
        </div>
        <div className="flex items-center gap-4">
          <span className="text-lg text-white">{welcomeMessage}</span>
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <button>
                <Avatar className="">
                  <AvatarFallback className="flex size-8 cursor-pointer items-center justify-center rounded-full border border-white/30 bg-white/20 text-sm text-white transition-all duration-200 hover:border-white/50 hover:bg-white/30">
                    {getInitials(user?.name)}
                  </AvatarFallback>
                </Avatar>
              </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent
              className="z-[1000] w-[--radix-dropdown-menu-trigger-width] min-w-56 rounded-lg"
              side={"bottom"}
              align={"end"}
            >
              <DropdownMenuItem
                onSelect={(e) => {
                  e.preventDefault();
                  handleSignOut();
                }}
              >
                <LogOut />
                Sign Out
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
    </header>
  );
}
